import { User } from './security.models';
export let user: User = new User();


// WEBPACK FOOTER //
// ./node_modules/@rx/security/user.ts